import { render, staticRenderFns } from "./JqueryLicenseView.vue?vue&type=template&id=12e8567c&scoped=true"
import script from "./JqueryLicenseView.vue?vue&type=script&lang=js"
export * from "./JqueryLicenseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e8567c",
  null
  
)

export default component.exports